import { Routes, Route } from "react-router-dom";
import Index from "../pages/Index";
import Login from "../pages/Login";
import OAuthCallback from "../pages/OAuthCallback";
import Catalog from "../pages/Catalog";
import BookView from "../pages/BookView";
import BookCreate from "../pages/BookCreate";
import BookEdit from "../pages/BookEdit";
import MaterialityCalendar from "../pages/MaterialityCalendar";
import SimulationConfigs from "../pages/SimulationConfigs";
import Simulation from "../pages/Simulation";
import SimulationDetails from "../pages/SimulationDetails";
import SimulationResults from "../pages/SimulationResults";
import ParametersV2 from "../pages/ParametersV2";
import NotFound from "../pages/NotFound";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { PublicRoute } from "../components/PublicRoute";

export default function Router() {
  return (
    <Routes>
      {/* Rotas Públicas */}
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route path="/auth/google_oauth2" element={<OAuthCallback />} />

      {/* Rotas Privadas */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Index />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog"
        element={
          <ProtectedRoute>
            <Catalog />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/:id"
        element={
          <ProtectedRoute>
            <BookView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/:id/editar"
        element={
          <ProtectedRoute>
            <BookEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/criar/novo"
        element={
          <ProtectedRoute>
            <BookCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/catalog/create"
        element={
          <ProtectedRoute>
            <BookCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/materialidades"
        element={
          <ProtectedRoute>
            <MaterialityCalendar />
          </ProtectedRoute>
        }
      />
      <Route
        path="/simulacoes"
        element={
          <ProtectedRoute>
            <SimulationConfigs />
          </ProtectedRoute>
        }
      />
      <Route
        path="/simulacoes/simulacao"
        element={
          <ProtectedRoute>
            <Simulation />
          </ProtectedRoute>
        }
      />
      <Route
        path="/simulacoes/:id"
        element={
          <ProtectedRoute>
            <SimulationDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/simulacoes/:id/resultados"
        element={
          <ProtectedRoute>
            <SimulationResults />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parametros"
        element={
          <ProtectedRoute>
            <ParametersV2 />
          </ProtectedRoute>
        }
      />

      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

